import Label from 'Components/Label';
import { useEffect, useState } from 'react';
import moment from 'moment';
import CreditoService from 'Services/Http/Credito.service';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setId } from '../../../../redux/slices';
import SearchBar from 'Components/SearchBar';
import ProgressBar from 'Components/ProgressBar';
import ButtonDeleteExpediente from 'Components/ButtonDeleteExpediente';

const ListarSolicitudesComponente = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [clientes, setClientes] = useState([]);
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    getAllClientes();
  }, []);

  const activeExpedient = (uuid, id) => {
    const url = '/main/expediente/' + uuid + '/renovacion';
    const dataId = [];
    dataId[uuid] = id;
    dispatch(setId(dataId));
    goTo(url);
  };

  const goTo = (url) => {
    navigate(url);
  };

  const getAllClientes = async () => {
    setLoader(true);
    try {
      setClientes([]);
      const response = await CreditoService.solicitudes();
      createRows(response.data);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };
  const createRows = (rows) => {
    let data = rows.map((item, index) => (
      <tr
        key={'clientes-row-' + index}
        className="odd:bg-white even:bg-blue-100 border-b hover:bg-blue-300 hover:cursor-pointer">
        <td className="px-6 py-4" onClick={() => activeExpedient(item.uuid, item.id)}>
          {item.id}
        </td>
        <td className="px-6 py-4" onClick={() => activeExpedient(item.uuid, item.id)}>
          {item.nombreCompleto}
        </td>
        <td className="px-6 py-4" onClick={() => activeExpedient(item.uuid, item.id)}>
          {item.edad}
        </td>
        <td className="px-6 py-4" onClick={() => activeExpedient(item.uuid, item.id)}>
          {item.fechaNacimiento}
        </td>
        <td className="px-6 py-4" onClick={() => activeExpedient(item.uuid, item.id)}>
          {moment(item.created_at).format('DD/MM/YYYY')}
        </td>
        <td className="px-6 py-4" onClick={() => activeExpedient(item.uuid, item.id)}>
          {item.creador}
        </td>
        <td className="px-6 py-4" onClick={() => activeExpedient(item.uuid, item.id)}>
          {moment(item.fechaAsignacion).format('DD/MM/YYYY')}
        </td>
        <td className="px-6 py-4" onClick={() => activeExpedient(item.uuid, item.id)}>
          {item.asignado}
        </td>
        <td className="px-6 py-4">
          <ButtonDeleteExpediente refresh={getAllClientes} id={item.id} prospecto={false} />
        </td>
      </tr>
    ));
    setClientes(data);
    setLoader(false);
  };
  const find = async (text) => {
    setClientes([]);
    const response = await CreditoService.solicitudes(text);
    createRows(response.data);
  };
  return (
    <>
      <Label text={'Solicitudes de clientes'} />
      <div className="flex flex-col grid grid-cols-1 md:grid md:grid-flow-col md:grid-cols-2 md:flex-row gap-3 my-3 justify-stretch">
        <div className="flex order-2 md:order-1">
          <SearchBar find={find} reload={getAllClientes} />
        </div>
      </div>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left rtl:text-right text-black">
          <thead className="text-xs text-white uppercase bg-blue-500">
            <tr>
              <th scope="col" className="px-6 py-3">
                #
              </th>
              <th scope="col" className="px-6 py-3">
                Nombre completo
              </th>
              <th scope="col" className="px-6 py-3">
                Edad
              </th>
              <th scope="col" className="px-6 py-3">
                Fecha de nacimiento
              </th>
              <th scope="col" className="px-6 py-3">
                Fecha creacion
              </th>
              <th scope="col" className="px-6 py-3">
                Creado
              </th>
              <th scope="col" className="px-6 py-3">
                Fecha asignacion
              </th>
              <th scope="col" className="px-6 py-3">
                Asignado
              </th>
              <th scope="col" className="px-6 py-3"></th>
            </tr>
          </thead>
          <tbody>{clientes}</tbody>
        </table>
        {loader ? <ProgressBar /> : ''}
      </div>
    </>
  );
};

export default ListarSolicitudesComponente;
